/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '../../../common/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/virtual-agent-ai-answers-app-skeleton.tpl.svg';

const customCssStyles = css({
	margin: '0 auto',
	maxWidth: '960px',
});

export const VirtualAgentAiAnswersSkeleton = () => (
	<AppSkeletonImage src={imgSVG} css={customCssStyles} />
);
